module.exports = __webpack_public_path__ + "static/people-one-a2f5c264205ad4876d5d9398a8adaebb.jpg";